import React, { useState, useEffect } from 'react'
import i18next from 'i18next'
import '../../i18n/config'
import { useTranslation, initReactI18next } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import { downloadList } from 'gatsby-theme-kn/src/utils/media_database_download_list'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'
import Image from 'gatsby-theme-kn/src/components/atoms/Image'

const ModalMediaDatabaseDownloadList = ({ downloadListId }) => {
  const { t } = useTranslation()

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    {},
    'get'
  )

  useEffect(() => {
    if (downloadListId) {
      setPartnerPortalUrl(apiURL('upload_lists/' + downloadListId))
    }
  }, [downloadListId])

  const locale = i18next.use(initReactI18next).language

  const downloadListUrl = function () {
    return (
      process.env.WEBSITE_URL +
      '/' +
      locale +
      '/medien/#!download_list/' +
      downloadListId
    )
  }

  const downloadListZip = function (type, only) {
    return apiURL(
      'upload_lists/' + downloadListId + '/download/' + type + '?only=' + only
    )
  }

  const showUploads = function (data) {
    return (
      <>
        {t('generic.spa.media.show.image_files')}
        &nbsp; ({data.images.length})
        <div className="media-detail-downloads">
          <a href={downloadListZip('hires_cmyk', 'images')}>
            <i className="fal fa-file-archive"></i>
            &nbsp;
            {t('generic.spa.media.show.hires_cmyk')}
          </a>
          <br />

          <a href={downloadListZip('hires_rgb', 'images')}>
            <i className="fal fa-file-archive"></i>
            &nbsp;
            {t('generic.spa.media.show.hires_rgb')}
          </a>
          <br />

          <a href={downloadListZip('office_rgb', 'images')}>
            <i className="fal fa-file-archive"></i>
            &nbsp;
            {t('generic.spa.media.show.office_rgb')}
          </a>
          <br />

          <a href={downloadListZip('internet_rgb', 'images')}>
            <i className="fal fa-file-archive"></i>
            &nbsp;
            {t('generic.spa.media.show.internet_rgb')}
          </a>
        </div>
        <div className="downloads">
          <div className="download-cards">
            <div className="download-card-deck download-card-deck-horizontal">
              {data.images.map((item, index) => (
                <div
                  className="download-card"
                  data-upload-id={item.id}
                  key={index}
                >
                  <img
                    className="card-img"
                    src={item.urls.thumbnail}
                    title={item.filename}
                  />
                  <div className="download-title">{item.title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    )
  }

  const showDocuments = function (data) {
    return (
      <>
        {t('generic.spa.media.show.document_files')}
        &nbsp; ({data.documents.length})
        <div className="media-detail-downloads media-detail-downloads-fill-height-md">
          <a href={downloadListZip('original', 'documents')}>
            <i className="fal fa-file-archive"></i>
            &nbsp;
            {t('generic.spa.media.show.original_documents')}
          </a>
        </div>
        <div className="downloads">
          <div className="download-cards">
            <div className="download-card-deck download-card-deck-horizontal">
              {data.documents.map((item, index) => (
                <div className="download-card" data-upload-id="{item.id}">
                  <img
                    className="card-img"
                    src={item.urls.thumbnail}
                    title={item.filename}
                  />
                  <div className="download-title">{item.title}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="media-detail">
      {loading && <LoadingSpinner />}
      {data && (
        <div className="media-detail-basics">
          <dl className="row">
            <dt className="col-sm-3">
              {t('generic.spa.media.index.download_list_copy')}
            </dt>

            <dd className="col-sm-9">
              <div className="input-group mb-1">
                <input
                  className="form-control"
                  id="link-download-list"
                  value={downloadListUrl()}
                  readOnly
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    data-clipboard-target="#link-download-list"
                    title={t('generic.spa.media.show.copy_to_clipboard')}
                    onClick={() => {
                      navigator.clipboard.writeText(downloadListUrl())
                    }}
                  >
                    <i className="fal fa-copy"></i>
                  </button>
                </div>
              </div>
            </dd>
            {data.alternatives && data.alternatives.length > 0 && (
              <>
                <dt className="col-sm-3">
                  {t('generic.spa.media.show.alternative_files')}
                  &nbsp; ({data.alternatives.length})
                </dt>
                <dd className="col-sm-9">
                  <div className="media-detail-downloads">
                    <div className="downloads">
                      <div className="download-cards">
                        <div className="download-card-deck download-card-deck-horizontal">
                          {data.alternatives.map((alternative, index) => (
                            <div
                              className="download-card"
                              data-upload-id={alternative.id}
                              key={index}
                            >
                              <Image
                                image={alternative.urls.original}
                                className="card-img"
                                title={alternative.title}
                                alt={alternative.title}
                                imageWidth="210"
                                imageHeight="210"
                                fillColor="f6f6f6"
                              />
                              <div
                                className="download-title"
                                style={{ height: 'auto' }}
                              >
                                {alternative.title}
                                <br />
                                <div className="media-detail-downloads">
                                  {alternative.urls.alternative && (
                                    <a
                                      href={alternative.urls.alternative}
                                      target="_blank"
                                    >
                                      {t(
                                        'generic.spa.media.show.open_external'
                                      )}
                                    </a>
                                  )}
                                  {!alternative.urls.alternative && (
                                    <a
                                      href="#!upload_webviewer/{alternative.id}"
                                      data-navigo
                                    >
                                      {t(
                                        'generic.spa.media.show.open_external'
                                      )}
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </dd>
              </>
            )}

            {data.logos && data.logos.length > 0 && (
              <>
                <dt className="col-sm-3">
                  {t('generic.spa.media.show.logo_files')}
                  &nbsp; ({data.logos.length})
                </dt>
                <dd className="col-sm-9">
                  <div className="media-detail-downloads">
                    <a href={downloadListZip('original', 'logos')}>
                      <i className="fal fa-file-archive"></i>
                      &nbsp;
                      {t('generic.spa.media.show.original_logos')}
                    </a>
                    <br />
                    <a href={downloadListZip('office_rgb_png', 'logos')}>
                      <i className="fal fa-file-archive"></i>
                      &nbsp;
                      {t('generic.spa.media.show.office_rgb_png')}
                    </a>
                    <br />
                    <a href={downloadListZip('internet_rgb_png', 'logos')}>
                      <i className="fal fa-file-archive"></i>
                      &nbsp;
                      {t('generic.spa.media.show.internet_rgb_png')}
                    </a>

                    <div className="downloads">
                      <div className="download-cards">
                        <div className="download-card-deck download-card-deck-horizontal">
                          {data.logos.map((logo, index) => (
                            <div className="download-card" key={index}>
                              <Image
                                image={logo.urls.original}
                                className="card-img"
                                title={logo.title}
                                alt={logo.title}
                                imageWidth="210"
                                imageHeight="210"
                                fillColor="f6f6f6"
                              />
                              <div className="download-title">{logo.title}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </dd>
              </>
            )}

            {data.uploads && (
              <>
                <dt className="col-sm-3">
                  {t('generic.spa.media.index.download_list_download')}
                </dt>
                <dd className="col-sm-9">
                  {data.documents &&
                    data.documents.length > 0 &&
                    data.images &&
                    data.images.length > 0 && (
                      <div className="row">
                        <div className="col-md-6">
                          {data.images.length > 0 && showUploads(data)}
                        </div>
                        <div className="col-md-6">{showDocuments(data)}</div>
                      </div>
                    )}

                  {data.documents.length == 0 && data.images.length > 0 && (
                    <div className="row">
                      <div className="col-md-12">{showUploads(data)}</div>
                    </div>
                  )}

                  {data.images.length == 0 && data.documents.length > 0 && (
                    <div className="row">
                      <div className="col-md-12">{showDocuments(data)}</div>
                    </div>
                  )}
                </dd>
              </>
            )}
          </dl>
        </div>
      )}

      {/*
        <pre>{JSON.stringify(data, null, 2)}</pre>
      */}
    </div>
  )
}

export default ModalMediaDatabaseDownloadList
